import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_confirm_modal = _resolveComponent("confirm-modal")!
  const _component_status_modal = _resolveComponent("status-modal")!
  const _component_standart_template = _resolveComponent("standart-template")!

  return (_openBlock(), _createBlock(_component_standart_template, { class: "h-full" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: item.title,
          to: item.route,
          class: "mb-3 flex h-[116px] items-center justify-between rounded-md bg-greyLight px-4 py-2 text-grey"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(item.title), 1),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "pr-4" }, [
              _createElementVNode("i", { class: "fas fa-chevron-right" })
            ], -1))
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128)),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirectToWiki && _ctx.redirectToWiki(...args))),
        class: "mb-3 flex h-[116px] cursor-pointer items-center justify-between rounded-md bg-greyLight px-4 py-2 text-grey"
      }, [...(_cache[8] || (_cache[8] = [
        _createElementVNode("div", null, "Помощь с приложением", -1),
        _createElementVNode("div", { class: "pr-4" }, [
          _createElementVNode("i", { class: "fas fa-chevron-right" })
        ], -1)
      ]))]),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
        class: "mb-3 flex h-[116px] items-center justify-between rounded-md bg-greyLight px-4 py-2 text-red"
      }, [...(_cache[9] || (_cache[9] = [
        _createElementVNode("div", null, "Выход", -1),
        _createElementVNode("div", { class: "pr-4" }, [
          _createElementVNode("i", { class: "fas fa-chevron-right" })
        ], -1)
      ]))]),
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmModalDialog = true)),
        class: "flex h-[116px] items-center justify-between rounded-md bg-greyLight px-4 py-2 text-red"
      }, [...(_cache[10] || (_cache[10] = [
        _createElementVNode("div", null, "Удалить профиль", -1),
        _createElementVNode("div", { class: "pr-4" }, [
          _createElementVNode("i", { class: "fas fa-chevron-right" })
        ], -1)
      ]))]),
      (_ctx.shouldShowUpdateButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "absolute py-5 bottom-[100px] left-[50%] translate-x-[-50%] w-[90%] my-[8px] text-center bg-[#ffd930] text-sm rounded-xl leading-5",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openNewVersionModal()))
          }, " Обновить приложение "))
        : _createCommentVNode("", true),
      _createVNode(_component_confirm_modal, {
        state: _ctx.confirmModalDialog,
        "confirm-button-text": "Да",
        description: 'Вы действительно хотите удалить аккаунт?',
        "decline-button-text": "Нет",
        onDecline: _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmModalDialog = false)),
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => {
        _ctx.statusModalDialog = true;
        _ctx.confirmModalDialog = false;
      })
      }, null, 8, ["state"]),
      _createVNode(_component_status_modal, {
        type: "success",
        description: "Заявка на удаление передана партнеру!",
        state: _ctx.statusModalDialog,
        "button-text": "Хорошо",
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (_ctx.logout()))
      }, null, 8, ["state"])
    ]),
    _: 1
  }))
}